// Fonte única -- usada pela FAQ da home (`Homepage/sections/FAQ`) E pela
// página de suporte (`pages/Support`). Pedido explícito do Pedro pra não
// ter duas listas de perguntas divergentes: qualquer revisão de conteúdo
// deve mudar só aqui.
interface IFaqEntry {
  q: string;
  a: string;
}

const faqs: IFaqEntry[] = [
  {
    q: 'Como funciona o período de teste grátis de 15 dias?',
    a: 'Você cria sua conta em menos de 2 minutos, sem necessidade de cadastrar cartão de crédito. Durante 15 dias, você tem acesso completo a todas as funcionalidades da plataforma (incluindo os recursos do plano Performance) para testar com sua equipe e alunos.',
  },
  {
    q: 'Preciso instalar algum programa nos computadores da academia?',
    a: 'Não. O painel administrativo é 100% online e funciona direto pelo navegador em qualquer computador, tablet ou celular. Os aplicativos para alunos e instrutores estão disponíveis para download gratuito na App Store (iOS) e Google Play (Android).',
  },
  {
    q: 'O que acontece se minha academia ultrapassar o limite de alunos do plano?',
    a: 'Você não perde o acesso e seus alunos continuam treinando normalmente. Caso alcance o limite do seu plano atual (ex: 120 alunos no Crescimento), você pode solicitar a alteração para o plano seguinte ou pacotes adicionais de expansão diretamente com o nosso suporte.',
  },
  {
    q: 'Meus alunos pagam para baixar ou usar o aplicativo?',
    a: 'Não! O aplicativo é totalmente gratuito para todos os alunos cadastrados pela sua academia.',
  },
  {
    q: 'Posso cadastrar meus próprios exercícios além da biblioteca padrão?',
    a: 'Com certeza. Todos os planos permitem o cadastro de exercícios customizados com nome, categoria e orientações próprias para manter o padrão de treino do seu espaço.',
  },
  {
    q: 'Existe contrato de fidelidade ou taxa de cancelamento?',
    a: 'Nenhum. Nossos planos são mensais e você pode cancelar a assinatura a qualquer momento, sem multas ou taxas ocultas.',
  },
  {
    q: 'Como funciona o suporte e o treinamento para a minha equipe?',
    a: 'Disponibilizamos tutoriais em vídeo, documentação passo a passo e suporte direto via e-mail e canais de atendimento para ajudar você e seus instrutores na configuração inicial.',
  },
  {
    q: 'O mesmo usuário pode ter perfis diferentes (gestor, instrutor ou aluno)?',
    a: 'Sim! A plataforma possui gestão de múltiplos vínculos em uma única conta. O usuário pode alternar facilmente entre o perfil de gestor em um espaço, instrutor em outro e aluno em uma terceira academia sem precisar criar logins diferentes.',
  },
  {
    q: 'Alunos podem usar o aplicativo sem vínculo com uma academia?',
    a: 'Sim! O aplicativo do aluno possui a modalidade Standalone gratuita. Qualquer pessoa pode baixar o app, criar seu próprio perfil e gerenciar seus treinos de forma autônoma para sempre, sem nenhum custo.',
  },
];

export type { IFaqEntry };
export { faqs };
